import { render, staticRenderFns } from "./relevaceTime.vue?vue&type=template&id=54781066"
import script from "./relevaceTime.vue?vue&type=script&lang=js"
export * from "./relevaceTime.vue?vue&type=script&lang=js"
import style0 from "./relevaceTime.vue?vue&type=style&index=0&id=54781066&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports